import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import rulesReducer from './slices/rulesSlice';
import analyticsReducer from './slices/analyticsSlice';
import languageReducer from './slices/languageSlice';
import supportReducer from './slices/supportSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    rules: rulesReducer,
    analytics: analyticsReducer,
    language: languageReducer,
    support: supportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
